<script>
  import axios from "axios";
  import { createEventDispatcher } from "svelte";
  import CrabIcon from "./icons/CrabIcon.svelte";

  let formInput = "";
  let formErrorState = null;
  let submitting = false;
  let serverErrorMessage = null;

  const dispatch = createEventDispatcher();

  async function handleSubmit(event) {
    event.preventDefault();
    const input = formInput.trim();
    const uuidRegex = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/;
    if (!input.match(uuidRegex)) {
      return (formErrorState = {
        invalid: true,
        message: "API Key is Invalid"
      });
    }
    formErrorState = null;
    submitting = true;
    try {
      await submitAPIKey(input);
      dispatch("sessionUpdated");
      submitting = false;
    } catch (err) {
      submitting = false;
      serverErrorMessage = err.response.data.error;
    }
  }

  async function submitAPIKey(key) {
    const res = await axios.post("user", { key });
    return res;
  }
</script>

<style>
  section {
    align-items: center;
    background: var(--white);
    border-radius: 3px;
    box-shadow: var(--card-box-shadow);
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }

  h2 {
    font-family: var(--font-family-heading);
    text-align: center;
    font-size: 1.75rem;
    margin-bottom: 0.5rem;
  }

  p {
    text-align: center;
    font-weight: normal;
    margin: 0.75rem;
    max-width: 650px;
    line-height: 1.4;
  }

  p,
  label,
  button {
    font-family: var(--font-family-heading);
  }

  form {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0.5rem;
  }

  button {
    background: var(--blue);
    border: none;
    color: var(--white);
    display: block;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
  }

  button:hover {
    cursor: pointer;
  }

  input {
    border: 2px solid #ddd;
    border-radius: 3px;
    font-size: 0.9rem;
    padding: 0.6rem;
    margin: 0.5rem 0 0;
    text-align: center;
    width: 300px;
  }

  label {
    font-weight: 700;
  }

  .input-error {
    border-color: red;
  }

  input::placeholder {
    color: #bbb;
  }

  .error {
    color: red;
    margin: 0.2rem;
  }

  .note {
    color: #555;
    font-size: 0.75rem;
  }

  .server-error-message {
    background: rgb(255, 196, 196);
    border: 1px solid rgb(160, 0, 0);
    color: rgb(160, 0, 0);
    padding: 0.5rem;
    max-width: 650px;
    width: 100%;
  }

  .server-error-message p {
    text-align: left;
  }

  @media screen and (max-width: 768px) {
    section {
      margin: 0 0.75rem;
    }
  }
</style>

<section>
  <CrabIcon className={'welcome-crab'} />
  <h2>Welcome to Kani-Cram!</h2>
  <p>
    Kani-Cram is a customizable listing of all the Radicals/Kanji/Vocabulary
    you've currently studied on WaniKani. It also has a bunch of other cool
    features like filtering and sorting items based on your progress.
  </p>
  <p>Enter your API key below to get started!</p>
  {#if serverErrorMessage}
    <div class="server-error-message">
      <p>The following errors occurred during submission. Please try again.</p>
      <ul>
        <li>{serverErrorMessage}</li>
      </ul>
    </div>
  {/if}
  {#if submitting}
    <p>Submitting...</p>
  {:else}
    <form id="login-form" on:submit={handleSubmit}>
      <label for="login-input">API Key</label>
      <input
        id="login-input"
        class:input-error={formErrorState}
        bind:value={formInput}
        placeholder="00000000-0000-0000-0000-000000000000" />
      <p class="note">
        Note: Kani-Cram does not store your API key on our servers. His pincers
        are too small to do that.
      </p>
      {#if formErrorState}
        <div class="error">{formErrorState.message}</div>
      {/if}
      <button>Submit</button>
    </form>
  {/if}
</section>
